export default __webpack_public_path__ + "static/media/default.03e7580024809987b875cdafd45426c2.png";